import { TriangleAlert } from 'lucide-react'

import { Alert, AlertDescription } from '@/shared/ui/primitives/alert'

type DayCapacityNoticeProps = {
  totalCapacity?: number
  confirmedSeats?: number
  partySize: number
  originalHeadcount?: number
  subject?: string
}

function DayCapacityNotice({
  totalCapacity,
  confirmedSeats,
  partySize,
  originalHeadcount,
  subject = 'Booking this party',
}: DayCapacityNoticeProps) {
  if (totalCapacity == null) return null

  const projected = (confirmedSeats ?? 0) - (originalHeadcount ?? 0) + partySize
  if (projected <= totalCapacity) return null

  return (
    <Alert variant="warning">
      <TriangleAlert className="size-4" />
      <AlertDescription>
        {subject} would put {projected} hunters on this day, over the daily limit of{' '}
        {totalCapacity}.
      </AlertDescription>
    </Alert>
  )
}

export { DayCapacityNotice }
export type { DayCapacityNoticeProps }
